<div class="ft-panel" (click)="showModal.emit()">
    <div class="ft-heading ft-text-plus-2">{{ 'flipto.account.sections.platform.photoAdvocacy.Finalist' | translate }}</div>
    @if (!(finalistIncentives()?.firstWinnerIncentive || finalistIncentives()?.secondWinnerIncentive || finalistIncentives()?.thirdWinnerIncentive)) {
        <div>
            <span>{{ 'flipto.components.goals.NoGoalsHaveBeenSet' | translate }}</span>
        </div>
    }
    @if (finalistIncentives()?.firstWinnerIncentive) {
        <div class="goal-group">
            <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.FirstPlace' | translate }}</div>
            <span [innerHTML]="getPropertyIncentive(finalistIncentives()?.firstWinnerIncentive) | incentiveName"></span>
        </div>
    }
    @if (finalistIncentives()?.secondWinnerIncentive) {
        <div class="goal-group">
            <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.SecondPlace' | translate }}</div>
            <span [innerHTML]="getPropertyIncentive(finalistIncentives()?.secondWinnerIncentive) | incentiveName"></span>
        </div>
    }
    @if (finalistIncentives()?.thirdWinnerIncentive) {
        <div class="goal-group">
            <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.ThirdPlace' | translate }}</div>
            <span [innerHTML]="getPropertyIncentive(finalistIncentives()?.thirdWinnerIncentive) | incentiveName"></span>
        </div>
    }
    @if (finalistIncentives()?.runnerUpsIncentive) {
        <div class="goal-group">
            <div class="ft-label">
                {{ finalistIncentives().runnerUpsIncentive['@totalRunnerUps'] }}
                {{ 'flipto.account.sections.platform.photoAdvocacy.RunnerUps' | translate }}
            </div>
            <span [innerHTML]="getPropertyIncentive(finalistIncentives()?.runnerUpsIncentive) | incentiveName"></span>
        </div>
    }
    @if (finalistIncentives()?.finalistIncentive) {
        <div class="goal-group">
            <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.Participant' | translate }}</div>
            <span [innerHTML]="getPropertyIncentive(finalistIncentives()?.finalistIncentive) | incentiveName"></span>
        </div>
    }
</div>
